module.exports = __webpack_public_path__ + "img/historyBackground.96c22377.jpg";